import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { getAppCfg, getTopupInfo, setTopupInfo } from "../../utils/common";
import { Grid, withStyles } from "@material-ui/core";
import Container from "../../components/Container";
import { ErrorIcon, SuccessIcon } from "../../components/icons";
import Typo from '../../components/CustomTypo';
import ModalAlert from "../../components/ModalAlert";
import { useHistory } from "react-router-dom";
import { paths } from "../../../portal.router.config";
import { payment } from "../../wsclient/crmservices/payment";
import crmservices from "../../wsclient/crmservices";
import ButtonCustom from "../../components/ButtonCustom";
import { connection } from "../../../portal.config";

function ProcessTopup(props) {
    const { classes, t } = props;
    const [ready, setReady] = useState(false);
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [isSuccess, setIsSuccess] = useState(false);
    const [integration, setIntegration] = useState(null);
    const [wallet, setWallet] = useState(null);

    const topupInfo = getTopupInfo();
    const navigate = useHistory();

    useEffect(() => {
        onLoad();
    }, [])

    useEffect(() => {
        if (integration && integration.id && wallet && wallet.id) {
            if (topupInfo && topupInfo.from == 'topup') createTopups();
        }
    },[integration, wallet])

    const onLoad = async () => {
        onShowLoading(true);
        let searchStr = window.location.search;
        let token = topupInfo && topupInfo.token ? topupInfo.token : '';
        if (token && searchStr && searchStr.search(token) > 0 && searchStr.includes('success')) {
            await getWalletInfo();
            await getIntegrations();
        }
        else {
            setReady(true);
            setIsSuccess(false);
        }
        onShowLoading(false);
    }

    const showMessage = (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        })
    }

    const createTopups = async () => {
        try {
            console.log("AAAA createTopups wallet: ", wallet)
            let urlStr = window.location.search;
            let searchStr = urlStr.split('/');
            let client_secret = searchStr ? searchStr[searchStr.length - 1] : null;
            let result = await payment.createTopups({
                integration_id: integration.id,
                amount: topupInfo && topupInfo.amount,
                wallet_id: wallet && wallet.wallet && wallet.wallet.id,
                client_secret: client_secret,
                payment_method: {
                    type: topupInfo && topupInfo.type,
                    id: topupInfo && topupInfo.payment_method_id,
                },
            })
            console.log("AAAA createTopups result: ", result)
            if (result.code == 'OK') {
                setReady(true);
                setIsSuccess(true);
                setTopupInfo({})
                if (topupInfo && topupInfo.from == 'topup') {
                    setTimeout(() => {
                        navigate.push(paths.home)
                    }, 2000);
                }
            } else {
                setReady(true);
                setIsSuccess(false);
            }
        } catch (error) {
            console.log("AAAA createPayment error: ", error)
        }
        setTopupInfo({})
    }

    const getIntegrations = async () => {
        if (connection.crmConfig.isOpenStripe) {
            setIntegration({ id: connection.crmConfig.stripeIntegration })
            return;
        }
        try {
            let portalConfig = getAppCfg();
            let result = await payment.getIntegrations({
                connector: 'SOLIDGATE'
            }, portalConfig.id);
            console.log("AAAA getIntegrations result: ", result)
            if (result.code == 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) setIntegration(result.data.content[0])
            }
        } catch (error) {
            console.log("AAAA getIntegrations error: ", error)
        }
    }

    const getWalletInfo = async () => {
        try {
            let result = await crmservices.account.getWalletInfo();
            if (result.code == 'OK') {
                setWallet(result.data);
            }
        } catch (error) {
            console.log("AAAA getWalletInfor error: ", error)
        }
    }

    if(ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item justify='center' container>
                    <Grid xs={12} sm={12} md={8} lg={6} item>
                        <Grid xs={12} item justify='center' container style={{ marginTop: 16 }}>
                            {isSuccess == true && <SuccessIcon style={{ width: 100, height: 100 }} />}
                            {isSuccess == false && <ErrorIcon style={{ width: 100, height: 100 }} />}
                        </Grid>
                        <Grid xs={12} item justify='center' container style={{ marginBottom: 16 }}>
                            {isSuccess == true && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('TOPUP_SUCCESS')}</Typo>}
                            {isSuccess == false && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('TOPUP_FAILED')}</Typo>}
                        </Grid>
                        <Grid item xs={12} justifyContent="center" container>
                            <ButtonCustom color={'primary'} onClick={() => navigate.push(paths.home)}>Back to Home</ButtonCustom>
                        </Grid>
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
            </Container >
        );
    else {
        return(
            <Container showLoading={showLoading}>
            </Container>
        )
    }    
}

const styles = theme => ({
    content: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',
        [theme.breakpoints.down('md')]: {
            width: '54%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '63%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%'
        }
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    item_image: {
        width: theme.spacing(9),
        height: theme.spacing(9),
        objectFit: 'containt',
        borderRadius: theme.spacing(9),
    },
    item_image_container: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
    },
    listItem: {
        marginTop: theme.spacing(7)
    },
    item: {
        margin: theme.spacing(5, 0, 5, 0)
    },
    item_icon_container: {
        // marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.button.category.backgroundColor,
    },
});

export default withStyles(styles)(withTranslation()(ProcessTopup));